import React, { useState } from 'react';
import '../../pages/Contact/ContactPage.css'
/* TypedJs */
import Typical from 'react-typical';

/* Multi idioma */
import { FormattedMessage } from 'react-intl';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    purpose: ''
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsLoading(false);
      setIsSubmitted(true);
      
      // Reset form after 3 seconds
      setTimeout(() => {
        setIsSubmitted(false);
        setFormData({
          name: '',
          email: '',
          phone: '',
          address: '',
          purpose: ''
        });
      }, 3000);
    }, 1500);
  };

  return (
    <section className="contactos" id="contactos">
      <div className="contact-header" data-aos="fade-down" data-aos-duration="800">
        <h2 className="heading">
          <FormattedMessage
            id='contact'
            defaultMessage='Contact'
          />
        </h2>
        <p className="contact-subtitle">
          <FormattedMessage
            id='contact-subtitle'
            defaultMessage="Let's work together! I'd love to hear from you."
          />
        </p>
      </div>

      <div className="contact-container">
        <div className="contact-info" data-aos="fade-right" data-aos-delay="300">
          <h3 className="titulo">
            <FormattedMessage
              id='contact-info'
              defaultMessage='Contact me by: '
            />
            <Typical
              className="site-contacto"
              loop={Infinity}
              wrapper="b"
              steps={[
                'Gmail', 1500,
                'WhatsApp', 1500,
                'Instagram', 1500,
                'Telegram', 1500,
                'Linkedin', 1500,
                'Github', 1500,
              ]}
            />
          </h3>

          <div className="icons">
            {[
              { 
                href: "mailto:chyarun727@gmail.com", 
                icon: "fas fa-envelope", 
                text: "Gmail",
                color: "#ff0000"
              },
              { 
                href: "https://api.whatsapp.com/send?phone=918082065540", 
                icon: "fab fa-whatsapp", 
                text: "Whatsapp",
                color: "#4fc35b"
              },
              { 
                href: "https://www.instagram.com/arun_ch0udhary_/", 
                icon: "fab fa-instagram", 
                text: "Instagram",
                color: "#E1306C"
              },
              { 
                href: "https://t.me/+918082065540", 
                icon: "fab fa-telegram", 
                text: "Telegram",
                color: "#1DA1F2"
              },
              { 
                href: "https://www.linkedin.com/in/arun-singh-5a0237303/", 
                icon: "fab fa-linkedin-in", 
                text: "Linkedin",
                color: "#2867B2"
              },
              { 
                href: "https://github.com/Arunchy07", 
                icon: "fab fa-github", 
                text: "GitHub",
                color: "#000"
              }
            ].map((social, index) => (
              <a 
                key={index}
                href={social.href} 
                target="_blank" 
                rel="noopener noreferrer" 
                data-aos="zoom-in" 
                data-aos-delay={index * 100}
                style={{ '--social-color': social.color }}
                className="social-link"
              >
                <div className="social-icon">
                  <i className={social.icon}></i>
                </div>
                <div className="text">
                  {social.text}
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="contact-form-container" data-aos="fade-left" data-aos-delay="300">
          <h3>
            <FormattedMessage
              id='send-message'
              defaultMessage='Send me a message'
            />
          </h3>
          
          {isSubmitted ? (
            <div className="success-message">
              <div className="success-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <h4>
                <FormattedMessage
                  id='thank-you'
                  defaultMessage='Thank you for contacting me!'
                />
              </h4>
              <p>
                <FormattedMessage
                  id='contact-confirm'
                  defaultMessage="I'll get back to you as soon as possible."
                />
              </p>
            </div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">
                  <FormattedMessage
                    id='name'
                    defaultMessage='Name'
                  />
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  <FormattedMessage
                    id='email'
                    defaultMessage='Email'
                  />
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">
                  <FormattedMessage
                    id='phone'
                    defaultMessage='Phone Number'
                  />
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="address">
                  <FormattedMessage
                    id='address'
                    defaultMessage='Address'
                  />
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="purpose">
                  <FormattedMessage
                    id='purpose'
                    defaultMessage='Purpose of Contact'
                  />
                </label>
                <textarea
                  id="purpose"
                  name="purpose"
                  value={formData.purpose}
                  onChange={handleChange}
                  rows="4"
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>
                    <FormattedMessage
                      id='sending'
                      defaultMessage='Sending...'
                    />
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane"></i>
                    <FormattedMessage
                      id='send'
                      defaultMessage='Send Message'
                    />
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default React.memo(Contact);